import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Link from 'gatsby-link'

import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  PaymentRequestButtonElement,
  StripeProvider,
  Elements,
  injectStripe,
} from 'react-stripe-elements-universal'

import { colors } from '../theme'
import { Block, ContentRow } from '../styleguide'

export default class PaymentsPage extends React.Component<{}> {
  render() {
    return (
      <StripeProvider apiKey={process.env.STRIPE_API_PUBLIC_KEY}>
        <ContentRow>
          <Elements>
            <CardForm fontSize={16} />
          </Elements>
        </ContentRow>
      </StripeProvider>
    )
  }
}

@injectStripe
class CardForm extends React.Component<{
  fontSize: string,
  stripe: StripeProps,
}> {
  handleSubmit = ev => {
    ev.preventDefault()
    this.props.stripe.createToken().then(payload => console.log('[token]', payload))
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Label>
          Card details
          <CardElement
            // onBlur={handleBlur}
            // onChange={handleChange}
            // onFocus={handleFocus}
            // onReady={handleReady}
            {...createOptions(this.props.fontSize)}
          />
        </Label>
        <Button>Subscribe</Button>
      </Form>
    )
  }
}

const createOptions = (fontSize: string) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  }
}

const Form = styled.div`
  padding-bottom: 2.5rem;
  margin-bottom: 2.5rem;
  box-shadow: 0 .1875rem 0 #e6ebf1;
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;
`
const Label = styled.label`
  color: #6b7c93;
  font-weight: 500;
  letter-spacing: 0.025em;
`
const Email = styled.input.attrs({ type: 'text', placeholder: 'tom@jerry.com' })`
  color: '#424770';
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: '0.025em';
  ::placeholder {
    color: #aab7c4;
  }

  display: block;
  margin: .625rem 0 1.25rem 0;
  max-width: 30rem;
  padding: .625rem .875rem;
  box-shadow: rgba(50, 50, 93, 0.14902) 0 .0625rem .1875rem, rgba(0, 0, 0, 0.0196078) 0 .0625rem 0;
  border-radius: .25rem;
  background: white;

  transition: all 150ms ease;
  &:hover {
    ${'' /* box-shadow:
      rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem,
      rgba(0, 0, 0, 0.0784314) 0 0 .0625rem
    ; */};
    box-shadow: rgba(50, 50, 93, 0.109804) 0 .25rem .375rem, rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem;
    transition: all 150ms ease;
  }
  &:focus {
    ${'' /* box-shadow:
      rgba(50, 50, 93, 0.109804) 0 .25rem .375rem,
      rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem
    ; */};
    box-shadow: 0 .4375rem .875rem rgba(50, 50, 93, 0.1), 0 .1875rem .375rem rgba(0, 0, 0, 0.08);
    transition: all 150ms ease;
  }
`

const Button = styled.button`
  white-space: nowrap;
  border: 0;
  outline: 0;
  display: inline-block;
  height: 2.5rem;
  line-height: 2.5rem;
  padding: 0 .875rem;
  box-shadow: 0 .25rem .375rem rgba(50, 50, 93, 0.11), 0 .0625rem .1875rem rgba(0, 0, 0, 0.08);
  color: #fff;
  border-radius: .25rem;
  font-size: .9375rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  background-color: ${colors.indigo[6]};
  text-decoration: none;
  transition: all 150ms ease;
  margin-top: 0.75rem;
  &:hover {
    color: #fff;
    cursor: pointer;
    background-color: #7795f8;
    transform: translateY(-.0625rem);
    box-shadow: 0 .4375rem .875rem rgba(50, 50, 93, 0.1), 0 .1875rem .375rem rgba(0, 0, 0, 0.08);
  }
  &:active {
    color: #fff;
    cursor: pointer;
    background-color: ${colors.indigo[8]};
    transform: translateY(.0625rem);
    box-shadow: 0 .1875rem .3125rem rgba(50, 50, 93, 0.1), 0 0 .0625rem rgba(0, 0, 0, 0.08);
  }
`



// WEBPACK FOOTER //
// ./src/pages/pay.js